import { createSelector } from 'reselect';

import type { StoreState } from 'src/store/types';

const selectFirstName = (state: StoreState) => state.firstName;
const selectLastName = (state: StoreState) => state.lastName;

export const selectUserEmail = (state: StoreState) =>
  (state.paymentInformation && state.paymentInformation.userEmail) ||
  state.userEmail;

export const selectFullName = createSelector(
  selectFirstName,
  selectLastName,
  (...names) => names.filter(Boolean).join(' '),
);
